module.exports = __webpack_public_path__ + "static/media/blog-detail-1.9fa5bc1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-detail-1.jpg
// module id = 1107
// module chunks = 33